module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("\n    Квартира " + _vm._s(_vm.apartment.number) + "\n    "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'apartment-edit',
        params: {
          apartment_id: _vm.apartment.id
        }
      }
    }
  }, [_vm._v("Редактировать квартиру")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'block-details',
        params: {
          block_id: _vm.$route.params.block_id
        }
      }
    }
  }, [_vm._v("← Назад к Квартирам")])], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Полный адрес")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.apartment.full_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Номер квартиры")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.apartment.number))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-view', {
    attrs: {
      "apartment-id": _vm.apartment.id
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-417e8782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/apartment/ApartmentDetails.vue
// module id = 629
// module chunks = 0